import styled from 'styled-components'

export const HeaderContainer = styled.div`
  padding: 5px;
`
